(() => {
  'use strict';
  const q = (selector, scope = document) => scope.querySelector(selector);
  const qa = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const key = d => `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;
  const observed = (year, month, day) => {
    const d = new Date(Date.UTC(year, month, day));
    if (d.getUTCDay() === 6) d.setUTCDate(d.getUTCDate() - 1);
    if (d.getUTCDay() === 0) d.setUTCDate(d.getUTCDate() + 1);
    return key(d);
  };
  const nth = (year, month, weekday, occurrence) => {
    const d = new Date(Date.UTC(year, month, 1));
    d.setUTCDate(1 + ((weekday - d.getUTCDay() + 7) % 7) + (occurrence - 1) * 7);
    return key(d);
  };
  const holidays = year => {
    const dates = [observed(year, 0, 1), observed(year, 5, 19), observed(year, 6, 4), observed(year, 10, 11), observed(year, 11, 25), observed(year + 1, 0, 1), nth(year, 0, 1, 3), nth(year, 1, 1, 3), nth(year, 8, 1, 1), nth(year, 9, 1, 2), nth(year, 10, 4, 4)];
    const memorial = new Date(Date.UTC(year, 5, 0));
    memorial.setUTCDate(memorial.getUTCDate() - ((memorial.getUTCDay() + 6) % 7));
    dates.push(key(memorial));
    return new Set(dates);
  };
  const addBusinessDays = (date, count) => {
    const d = new Date(date);
    let calendar = holidays(d.getUTCFullYear());
    for (let added = 0, safety = 0; added < count && safety < 300; safety++) {
      const oldYear = d.getUTCFullYear();
      d.setUTCDate(d.getUTCDate() + 1);
      if (oldYear !== d.getUTCFullYear()) calendar = holidays(d.getUTCFullYear());
      if (d.getUTCDay() !== 0 && d.getUTCDay() !== 6 && !calendar.has(key(d))) added++;
    }
    return d;
  };
  const formatDeliveryRange = (start, end, today) => {
    const locale = document.documentElement.lang || 'en';
    const showYear = start.getUTCFullYear() !== today.getUTCFullYear() || end.getUTCFullYear() !== today.getUTCFullYear();
    const options = {month: 'long', day: 'numeric', timeZone: 'UTC'};
    if (showYear) options.year = 'numeric';
    const format = new Intl.DateTimeFormat(locale, options);
    const sameMonth = start.getUTCFullYear() === end.getUTCFullYear() && start.getUTCMonth() === end.getUTCMonth();
    if (start.getTime() === end.getTime()) return format.format(start);
    if (sameMonth && !showYear && /^en(?:-|$)/i.test(locale)) return `${format.format(start)} - ${end.getUTCDate()}`;
    return `${format.format(start)} - ${format.format(end)}`;
  };
  const initDelivery = () => {
    const parts = new Intl.DateTimeFormat('en-CA', {timeZone: 'America/Denver', year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(new Date());
    const part = type => parts.find(p => p.type === type).value;
    const today = new Date(`${part('year')}-${part('month')}-${part('day')}T00:00:00Z`);
    qa('[data-bp-delivery]').forEach(el => {
      const arrival = q('[data-bp-arrival]', el), line = q('.bp-arrival', el), fallback = q('[data-bp-delivery-fallback]', el), note = q('[data-bp-delivery-estimate]', el);
      if (!arrival || !line || !fallback || !note) return;
      arrival.textContent = ''; line.hidden = true; note.hidden = true; fallback.hidden = false;
      if (el.dataset.bpCountry !== 'US') return;
      const values = ['productionMin', 'productionMax', 'transitMin', 'transitMax'].map(name => Number(el.dataset[name]));
      if (values.some(value => !Number.isInteger(value) || value < 1 || value > 100)) return;
      const [productionMin, productionMax, transitMin, transitMax] = values;
      if (productionMin > productionMax || transitMin > transitMax) return;
      const min = productionMin + transitMin, max = productionMax + transitMax;
      if (max > 100) return;
      arrival.textContent = formatDeliveryRange(addBusinessDays(today, min), addBusinessDays(today, max), today);
      fallback.hidden = true; line.hidden = false; note.hidden = false;
    });
  };
  const initGift = () => {
    const select = q('[data-bp-gift]');
    if (!select) return;
    let pending = Promise.resolve();
    select.addEventListener('change', () => {
      const selected = select.value;
      const status = q('[data-bp-gift-status]');
      pending = pending.catch(() => {}).then(async () => {
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const response = await fetch(`${root}cart/update.js`, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({attributes: {'Gift order': selected}})});
          if (!response.ok) throw new Error('Save failed');
          const data = await response.json();
          if (data.attributes['Gift order'] !== selected) throw new Error('Not saved');
          status.textContent = select.dataset.success;
        } catch (_) { status.textContent = select.dataset.error; }
      });
    });
  };
  const initHints = () => qa('[data-bp-copy]').forEach(button => button.addEventListener('click', async () => {
    const status = q('.bp-hint-status', button.closest('.bp-hint'));
    try { await navigator.clipboard.writeText(button.dataset.bpCopy); status.textContent = button.dataset.success; }
    catch (_) { status.textContent = button.dataset.error; }
  }));
  const reviewControllers = new WeakMap();
  const initEtsy = el => {
    if (reviewControllers.has(el)) return reviewControllers.get(el);
    let manifest, ordered, page = 0, sequence = 0;
    const chunks = new Map();
    const pageSize = 10;
    const list = q('[data-bp-review-list]', el), status = q('[data-bp-review-status]', el);
    const previous = q('[data-bp-review-prev]', el), next = q('[data-bp-review-next]', el), sort = q('[data-bp-review-sort]', el);
    const getChunk = async number => {
      if (!chunks.has(number)) {
        const base = new URL(el.dataset.manifest, location.href);
        const url = new URL(manifest.files[number], base);
        url.search = base.search;
        chunks.set(number, fetch(url).then(r => {if (!r.ok) throw new Error('Load failed'); return r.json();}));
      }
      try { return await chunks.get(number); } catch (error) { chunks.delete(number); throw error; }
    };
    const render = async () => {
      const current = ++sequence;
      status.textContent = el.dataset.loading; list.setAttribute('aria-busy', 'true'); previous.disabled = true; next.disabled = true;
      try {
        if (!manifest) {
          const response = await fetch(el.dataset.manifest);
          if (!response.ok) throw new Error('Load failed');
          manifest = await response.json();
        }
        ordered = Array.from({length: manifest.count}, (_, i) => i);
        if (sort.value !== 'recent') ordered.sort((a, b) => (Number(manifest.ratings[a]) - Number(manifest.ratings[b])) * (sort.value === 'highest' ? -1 : 1) || a - b);
        const selected = ordered.slice(page * pageSize, (page + 1) * pageSize);
        const loaded = await Promise.all([...new Set(selected.map(i => Math.floor(i / manifest.chunkSize)))].map(async n => [n, await getChunk(n)]));
        if (current !== sequence) return;
        const data = new Map(loaded), fragment = document.createDocumentFragment();
        selected.forEach(index => {
          const review = data.get(Math.floor(index / manifest.chunkSize))[index % manifest.chunkSize];
          const card = document.createElement('article');card.className = 'bp-review-card';
          const stars = document.createElement('p');stars.className = 'bp-review-stars';stars.setAttribute('aria-label', el.dataset.stars.replace('__RATING__', review.rating));stars.textContent = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
          const body = document.createElement('p');body.className = 'bp-review-body';body.textContent = review.body || '';
          const author = document.createElement('p');author.className = 'bp-review-author';author.textContent = review.name;
          const date = document.createElement('time');date.dateTime = review.date;date.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {month:'short',day:'numeric',year:'numeric',timeZone:'UTC'}).format(new Date(`${review.date}T00:00:00Z`));
          card.append(stars);if (typeof review.body === 'string' && review.body.trim()) card.append(body);card.append(author, date);fragment.append(card);
        });
        list.replaceChildren(fragment);
        status.textContent = el.dataset.range.replace('__START__', page * pageSize + 1).replace('__END__', Math.min((page + 1) * pageSize, manifest.count)).replace('__COUNT__', manifest.count.toLocaleString());
        previous.disabled = page === 0; next.disabled = (page + 1) * pageSize >= manifest.count;
      } catch (_) { if (current === sequence) status.textContent = el.dataset.error; }
      finally { if (current === sequence) list.removeAttribute('aria-busy'); }
    };
    sort.addEventListener('change', () => {page = 0;render();});
    previous.addEventListener('click', () => {page = Math.max(0, page - 1);render();});
    next.addEventListener('click', () => {page++;render();});
    reviewControllers.set(el, render);return render;
  };
  const initReviews = () => {
    qa('[data-bp-review-tabs]').forEach(hub => {
      const shopArchive = q('[data-bp-etsy]', hub);
      if (shopArchive) hub.addEventListener('bp:load-shop-reviews', () => initEtsy(shopArchive)());
      if (hub.dataset.bpEtsyLayout) {if (shopArchive) initEtsy(shopArchive)();return;}
      const buttons = qa('[data-review-target]', hub);
      const tablist = q('.bp-review-tab-buttons', hub);tablist.setAttribute('role', 'tablist');
      const activate = button => buttons.forEach(b => {
        const selected = b === button, panel = document.getElementById(b.dataset.reviewTarget);
        b.setAttribute('aria-selected', String(selected));b.tabIndex = selected ? 0 : -1;panel.hidden = !selected;
        if (selected) { const etsy = q('[data-bp-etsy]', panel);if (etsy) initEtsy(etsy)(); }
      });
      buttons.forEach((button, index) => {
        button.id = `bp-review-tab-${index}`;button.setAttribute('role','tab');
        const panel = document.getElementById(button.dataset.reviewTarget);panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby', button.id);
        button.addEventListener('click', () => activate(button));
        button.addEventListener('keydown', e => {
          let target;
          if (e.key === 'ArrowRight') target = buttons[(index + 1) % buttons.length];
          if (e.key === 'ArrowLeft') target = buttons[(index - 1 + buttons.length) % buttons.length];
          if (e.key === 'Home') target = buttons[0];
          if (e.key === 'End') target = buttons[buttons.length - 1];
          if (target) {e.preventDefault();target.focus();activate(target);}
        });
      });
      activate(buttons[0]);
    });
    qa('[data-bp-etsy]').filter(el => !el.closest('[data-bp-review-tabs]')).forEach(el => {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {if(entries.some(e=>e.isIntersecting)){observer.disconnect();initEtsy(el)();}}, {rootMargin:'200px'});observer.observe(el);
      } else initEtsy(el)();
    });
    // Judge.me scrolls to its widget when sorting changes. Leave its initial
    // sort alone so arriving from a product card starts at the top of the page.
    // Buyers can still choose photos first in the review sort menu.
  };
  const initSort = () => qa('.gift-sort select[name="sort_by"]').forEach(select => {
    select.addEventListener('change', () => {
      const url = new URL(location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      url.hash = 'bp-results';
      location.assign(url.href);
    });
  });
  const initCoupon = () => {
    qa('[data-bp-coupon-button]').forEach(button => {
      const selected = new URLSearchParams(location.search).get('bp_coupon');
      if (selected === button.dataset.code) {
        button.classList.add('is-selected');
        const label = q('[data-bp-coupon-label]', button);
        if (label) label.textContent = button.dataset.selected;
      }
    });
    qa('[data-bp-code-apply]').forEach(button => button.addEventListener('click', () => {
      const box = button.closest('[data-bp-code-entry]'), input = q('input', box);
      if (!input.value.trim()) { input.focus(); return; }
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      location.assign(root + 'discount/' + encodeURIComponent(input.value.trim()) + '?redirect=' + encodeURIComponent(root + 'cart'));
    }));
  };
  const init = () => {initDelivery();initHints();initReviews();initSort();};
  window.addEventListener('pageshow', initDelivery);
  document.addEventListener('visibilitychange', () => {if (!document.hidden) initDelivery();});
  if (q('[data-bp-delivery]')) window.setInterval(() => {if (!document.hidden) initDelivery();}, 60000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});else init();
})();
